import React, { memo } from 'react';
import type { Collection, List, Normalized } from 'lib/LobbyEntities';
import { type Mapping } from '../../../../../Builder';
import SoleOffer from './components/SoleOffer';
import OffersCarousel from './components/OffersCarousel';

interface OffersListProps {
  list: List;
  collection: Normalized<Collection>;
  mapping: Mapping;
  trackSectionScrolled: () => void;
}

const OffersList = ({ list, collection, mapping, trackSectionScrolled }: OffersListProps) => {
  const soleOffer = list.children.length === 1 ? list.children[0] : null;

  return (
    <>
      {soleOffer ? (
        <SoleOffer offer={soleOffer} mapping={mapping} />
      ) : (
        <OffersCarousel
          list={list}
          collection={collection}
          mapping={mapping}
          trackSectionScrolled={trackSectionScrolled}
        />
      )}
    </>
  );
};

export default memo(OffersList);
